import Cookies from '@arsenal/arsenal/modules/Cookies'
import classNames from 'classnames'
import Button from 'Components/button'
import getCarIds from 'lib/get-cars-from-series'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import React, { useEffect, useState } from 'react'
import fetch from 'lib/decorated-fetch'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
interface ICar {
  series_id: number
  cover_image: string
  min_price: number
  max_price: number
  series_name: string
}

function Card(props: ICar) {
  const { series_id, cover_image, min_price, max_price, series_name } = props
  const [carIds, setCarIds] = useState('')

  useEffect(() => {
    getCarIds(`${series_id}`)
      .then(setCarIds)
      .catch((err) => {
        // TODO:
      })
  }, [series_id])

  return (
    <div className="card">
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href={`/auto/series/${series_id}`} target="_blank">
        <img src={cover_image} className="cover zoom" />
      </a>

      <div className="info">
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href={`/auto/series/${series_id}`} target="_blank">
          <span className="series-name line-1">{series_name}</span>
        </a>
        <div className="button-group">
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a href={`/dealer/${series_id}`} target="_blank">
            <Button
              type="new_primary"
              className="price-btn"
              onClick={() => {
                sendTeaCommEvent('click_favour_item_inquiry', {
                  car_series_id: series_id,
                })
              }}
            >
              询底价
            </Button>
          </a>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a href={`/auto/params?carIds=${carIds}`} target="_blank">
            <Button
              type="default"
              className="config-btn"
              onClick={() => {
                sendTeaCommEvent('click_favour_item_config', {
                  car_series_id: series_id,
                })
              }}
            >
              配置
            </Button>
          </a>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a href={`/auto/series/${series_id}/images/wg-x-x-x`} target="_blank">
            <Button
              type="default"
              className="picture-btn"
              onClick={() => {
                sendTeaCommEvent('click_favour_item_pic', {
                  car_series_id: series_id,
                })
              }}
            >
              图片
            </Button>
          </a>
        </div>
        <a
          href={`/auto/series/${series_id}`}
          // eslint-disable-next-line react/jsx-no-target-blank
          target="_blank"
          onClick={() => {
            sendTeaCommEvent('click_favour_series_price', {
              car_series_id: series_id,
            })
          }}
        >
          <span className="price-range">{`${min_price}-${max_price}`}万</span>
        </a>
      </div>
      <style jsx>
        {`
          .card {
            height: 92px;
            width: 100%;
            display: flex;
            align-items: center;
          }
          .cover {
            height: 65px;
            width: 90px;
          }
          .info {
            margin-left: 10px;
            display: flex;
            flex-direction: column;
            position: relative;
          }
          .series-name {
            font-size: 14px;
            color: #1f2129;
            font-weight: 500;
            max-width: 88px;
            display: inline-block;
          }
          .button-group {
            margin-top: 6px;
            display: flex;
            align-items: center;
          }
          :global(.button-group .price-btn) {
            font-size: 12px;
            height: 24px;
            line-height: 24px;
          }
          :global(.button-group .config-btn, .button-group .picture-btn) {
            border-color: #c9cbd6;
            color: #1f2129;
            min-width: 48px;
            border-radius: 2px;
            margin-left: 4px;
            font-weight: normal;
            font-size: 12px;
            height: 24px;
            line-height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          :global(.button-group .config-btn:hover, .button-group
              .picture-btn:hover) {
            background-color: #f2f4fa;
            color: #1f2129;
            border-color: #c9cbd6;
          }
          .price-range {
            position: absolute;
            top: 0;
            right: 0;
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #e62021;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 500;
          }
        `}
      </style>
    </div>
  )
}

export default function Favour({
  className,
  quantity = 6,
}: {
  className?: string
  quantity?: number
}) {
  const [carItems, setCarItems] = useState<ICar[]>([])
  useEffect(() => {
    const web_id = Cookies('tt_webid') || ''
    const fetchData = async () => {
      const query = {
        web_id,
      }
      const json = await fetch(
        `/motor/m_api/pc_recommend_series?${serializeObject(query)}`
      )
      setCarItems(json?.data?.recommend_series?.list || [])
    }
    try {
      fetchData()
    } catch (err) {
      console.error(err)
    }
  }, [])
  return carItems.length > 0 ? (
    <div className={classNames('favour', className)}>
      <div className="title">猜你喜欢</div>
      <ul>
        {carItems.slice(0, quantity).map((carItem, index) => (
          <li key={`${carItem.series_id} ${index}`}>
            <Card {...carItem} />
          </li>
        ))}
      </ul>
      <style jsx>
        {`
          .favour {
            background-color: white;
            width: 320px;
            padding: 20px 16px 0 16px;
          }
          .title {
            color: #1f2129;
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 13px;
          }
          li:not(:last-child) {
            border-bottom: 1px solid #f2f4fa;
          }
        `}
      </style>
    </div>
  ) : null
}
